import React                   from 'react';
import UploadedFile            from 'assets/icons/Uploaded File.svg';
import ViewIcon                from 'assets/icons/View.svg';
import moment                  from 'moment';
import ReferralFilters         from './ReferralFilters';
import ReferTo                 from './ReferTo';
import Spinner                 from 'react-bootstrap/Spinner';

export function ReferralTable({listType, logs, setLog, specialties, loading, getLogs, meta, page, startDate, endDate, setStartDate, setEndDate}) {
  const EmptyRow = () => {
    return (
      <tr className="patient-card-row bg-white">
        <td colSpan="5" className="text-center font-size-7 fweight-500 py-4" style={{ borderRadius: "0.5em" }}>No referral log available</td>
      </tr>
    );
  }

  const doctorDetail = (log) => {
    if(log.referral_type === 'suggestion'){
      return {
        first_name: log.name,
        last_name: `(${log.practice_location})`
      }
    }else{
      return listType === 'By' ? log.referrer : log.referee;
    }
    
  }

  const Logs = () => {
    return logs.map((log, index) => {
      const doctor = doctorDetail(log);
      const url = log.referral_letter ? log.referral_letter.styles.origin.url : '#';

      return <tr key={`log-${index}`} className="referral-card-row bg-white">
        <td valign="top" className={ 'd-none d-lg-table-cell py-6 px-4' }>
          <p className="fweight-400 font-size-6 mb-2">{moment(log.created_at).format('Do MMM YYYY')}</p>
          <span>{moment(log.created_at).format('HH:mm A')}</span>
        </td>

        <td className="d-none d-lg-table-cell py-6 pr-4">
          <div className="font-size-6 fweight-400">{log.patient_name}</div>
        </td>
        <td className={ 'd-none d-lg-table-cell py-6 px-4 ' }>
          <p className="fweight-400 font-size-6 mb-2">{[doctor.title ,doctor.first_name, doctor.last_name].filter(Boolean).join(' ')}</p>
        </td>
        <td className={ 'd-none d-lg-table-cell py-6 pr-4' }>
          {log.referral_letter ? 
            <a href={url} target="_blank" rel="noreferrer" className="text-danger text-decoration-none">
              <img src={UploadedFile} alt="uploaded-file" />
              <span>{url.substring(url.lastIndexOf('/')+1)}</span>
            </a> 
            : '-'
          }
        </td>
        <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
          <img src={ ViewIcon } alt="view-letter" className="clickable mr-4 view-gl-icon" onClick={() => setLog({...log, list_type: listType, doctor: doctor})}/>
        </td>
      </tr>
    })
  }

  return (
    <>
    <ReferralFilters getLogs={getLogs} meta={meta} page={page} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate}/>
    {listType === 'To' && <ReferTo specialties={specialties} getLogs={getLogs}/>}
    {loading ? <div className="d-flex justify-content-center my-12"><Spinner animation="border" className="spinner"/></div> : 
      (<table className="w-100 referral-table">
        <thead className="d-none d-lg-table-header-group">
          <tr>
            {
              ['Date', 'Patient', `Refer ${listType}`, 'Uploaded File', 'Actions'].map((name, index) => {
                const padding = index > 0 ? 'pr-4' : 'px-4';
                return <th key={ 'table-header-' + name } className={ "font-size-7 fweight-500 " + padding }>{ name }</th>
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            logs.length === 0 ? <EmptyRow /> : <Logs />
          }
        </tbody>
      </table>
    )}
    </>
  );
}

export default ReferralTable;